interface HeroProps {
  scrollToSection: (id: string) => void;
}

export default function Hero({ scrollToSection }: HeroProps) {
  return (
    <section className="relative h-screen w-full overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/9f8a23a8587135794654f622df98e4b5.jpg)'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative h-full flex items-center justify-center">
        <div className="text-center text-white px-4 max-w-4xl mx-auto">
          <h2 className="text-5xl md:text-7xl font-bold mb-6" style={{ fontFamily: '"Pacifico", serif' }}>
            SEASIDE CAFE<br />
            "WAVE RIDER"
          </h2>
          <p className="text-xl md:text-3xl mb-12 font-light tracking-wide">
            波を感じ、潮風と過ごす、サステナブルな空間。
          </p>
          <button
            onClick={() => scrollToSection('concept')}
            className="bg-white text-gray-900 px-8 py-4 rounded-full text-lg font-semibold hover:bg-blue-50 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
          >
            もっと見る
          </button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}